/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ConfigurazioneFormCittadinoDTO { 
    configurazione?: any | null;
    comune_nome?: string;
    is_riservato_residenti?: boolean;
}

